import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { labourApi } from '../api/labourApi'; 
import { RootState } from '..';

export interface LabourState {
  labourDetails: any;
  loading: boolean;
  error: string | null;
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: LabourState = {
  labourDetails: null,
  loading: false,
  error: null,
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

const labourSlice = createSlice({
  name: 'labour',
  initialState,
  reducers: {
    setLabourDetails: (state, action: PayloadAction<any>) => {
      state.labourDetails = action.payload;
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    reset: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        labourApi.endpoints.saveLabourDetail.matchPending,
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        labourApi.endpoints.saveLabourDetail.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.labourDetails = action.payload;
          state.error = null;
        }
      )
      .addMatcher(
        labourApi.endpoints.saveLabourDetail.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message || 'Something went wrong';
        }
      );
  },
});

// Action creators are generated for each case reducer function
export const { setLabourDetails, setLoading, setError, reset } = labourSlice.actions;
export const getLabourDetails = (state: RootState) => state.labour.data;
export const getLabourTotalRecords = (state: RootState) => state.labour.totalRecords;

export default labourSlice.reducer;